import React from 'react';
import { useParams } from 'react-router-dom';
import FormTemplateBuilderTasksView from 'components/FormTemplateBuilder/FormTemplateBuilderView/FormTemplateBuilderTasksView';
import CircleLoader from '@lib/components/CircleLoader/CircleLoader';
import FormTemplateModals from './FormTemplateModals';
import { UseActionsResults } from './utils/useActions';
import { ModalManagementResult } from './utils/useModalManagement';

interface Props {
  useActionsResult: UseActionsResults;
  useModalManagementResult: ModalManagementResult;
  isViewOnly: boolean;
}

export default function FormTemplateTasksViewContainer(props: Props) {
  const { useActionsResult, useModalManagementResult, isViewOnly } = props;
  const { id = '' } = useParams();

  const { openDestroyModal, openScheduleModal } = useModalManagementResult;

  const {
    formTemplateData,
    formTemplateFirstLoading,
    formTemplateLoading,
    formTemplateVersionData,
    loadingState,
    onCreateTaskHandler,
    onDuplicateHandler,
    onEditHandler,
    onFormTemplateArchiveHandler,
    onTaskFormTemplateVersionBulkChange,
    onTaskFormTemplateVersionChange,
    tasksQueryHook,
    useBulkSelectResult,
  } = useActionsResult;

  if (formTemplateFirstLoading) {
    return <CircleLoader />;
  }

  return (
    <>
      <FormTemplateBuilderTasksView
        formTemplateData={formTemplateData}
        formTemplateId={id}
        formTemplateLoading={formTemplateLoading}
        formTemplateVersionData={formTemplateVersionData}
        isViewOnly={isViewOnly}
        loadingState={loadingState}
        onCreateTaskHandler={onCreateTaskHandler}
        onDuplicateHandler={onDuplicateHandler}
        onEditHandler={onEditHandler}
        onFormTemplateArchiveHandler={onFormTemplateArchiveHandler}
        onTaskFormTemplateVersionBulkChange={
          onTaskFormTemplateVersionBulkChange
        }
        onTaskFormTemplateVersionChange={onTaskFormTemplateVersionChange}
        openDestroyModal={openDestroyModal}
        openScheduleModal={openScheduleModal}
        tasksQueryHook={tasksQueryHook}
        useBulkSelectResult={useBulkSelectResult}
      />
      <FormTemplateModals
        useActionsResult={useActionsResult}
        useModalManagementResult={useModalManagementResult}
      />
    </>
  );
}
